export default {
  vermelho: '#c23616',
  verde: '#44bd32',
  amarelo: '#f0c11a',
  laranja: '#e1a32a',
  azulescuro: '#2f3640'
}
